module.exports = __webpack_public_path__ + "static/media/YB5M03_2.857a3d88.jpg";